import React, { Component } from 'react';
import PropTypes from 'prop-types';
import noScroll from 'no-scroll';
import { Portal } from 'react-portal';

import {
	Wrapper,
	CloseBtn,
	Background,
	InnerWrapper,
	OuterWrapper,
} from './overlayStyles';

import Close from 'core/icons/Close';

class Overlay extends Component {
	escapeListener = event => {
		const { dismiss } = this.props;
		if (event.keyCode === 27) {
			noScroll.off();
			if (dismiss) dismiss();
		}
	}

	componentDidMount () {
		noScroll.on();
		window.addEventListener('keyup', this.escapeListener);
	}

	componentWillUnmount () {
		noScroll.off();
		window.removeEventListener('keyup', this.escapeListener);
	}

	render = () => {
		const {
			dismiss,
			noCloseBtn,
			children,
			noOverflow,
			fromBottom,
		} = this.props;

		return (
			<Portal>
				<Wrapper>
					<OuterWrapper noOverflow={noOverflow} fromBottom={fromBottom}>
						<InnerWrapper>
							{children}
						</InnerWrapper>
					</OuterWrapper>

					<Background onClick={dismiss}>
						{!noCloseBtn && (
							<CloseBtn>
								<Close fill="currentColor" width={12} height={12} />
							</CloseBtn>
						)}
					</Background>
				</Wrapper>
			</Portal>
		);
	}

	static propTypes = {
		dismiss: PropTypes.func,
		children: PropTypes.node,
		noCloseBtn: PropTypes.bool,
		noOverflow: PropTypes.bool,
		fromBottom: PropTypes.bool,
	}

	static defaultProps = {
		noOverflow: true,
	}
}

export default Overlay;
